import { useState, useEffect } from 'react';
import Header from './Components/Header';
import { Box } from '@mui/material';

function App() {

const [isMobile, setIsMobile] = useState(window.innerWidth <= 1024);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 1024);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, []);
  
  return (
    <Box>
      {
        isMobile ?
            <Header isMobile={true}/>
          :
          <Box>
            <Header isMobile={false}/>
          </Box>
      }
    </Box>
  );
}

export default App;
